import { type ReactNode } from 'react';

export interface RailRecentsProps<T> {
  label?: string; // section heading, default "Recent"
  items: T[]; // the (already sorted + sliced) most-recent items
  idOf: (t: T) => string;
  isCurrent: (t: T) => boolean;
  onPick: (t: T) => void;
  renderRow: (t: T) => ReactNode; // the inner of the .orow button (Avatar + text)
  emptyText?: string;
}

// The standing "recent items" list for a master-detail rail — shown where there's
// no related-item timeline (a brand-new entity, or the timeline-less account
// modal). ONE component, reused by every modal, so the rail reads identically
// whether it's people, staff, owners or bookings. Reuses the shared .orow rows.
export function RailRecents<T>({ label = 'Recent', items, idOf, isCurrent, onPick, renderRow, emptyText }: RailRecentsProps<T>) {
  return (
    <div className="rail-recents">
      <div className="grouplbl"><span className="eyebrow">{label}</span><span className="eyebrow">{items.length}</span></div>
      <div className="recents-list">
        {items.length === 0 && emptyText ? (
          <div className="empty" style={{ padding: '20px 10px' }}>{emptyText}</div>
        ) : (
          items.map((t) => (
            <button
              key={idOf(t)}
              type="button"
              className={'orow' + (isCurrent(t) ? ' cur' : '')}
              onMouseDown={() => onPick(t)}
            >
              {renderRow(t)}
            </button>
          ))
        )}
      </div>
    </div>
  );
}
